<template>
<div class="mx-4 card-container">

    <!-- First Slider -->
    <div v-if="firstSlider" :style="{'background-color':bgColor}" class="splide impression-slider-container global-border-radius firstSlider newFeatureSlider mb-3" :class="{'shadow-s': addBorder == 'enable'}">
        <div class="sands-article-vueslidercontainer splide__track">
            <div class="splide__list">
                <div v-for="(data, i) in firstSlider" :key="'first_' + i" class="splide__slide px-4 py-4">
                    <div class="impression-sub-title">
                        <p class="" v-html="data['gdl-tab-Subtitle']"></p>
                        <p v-if="data['gdl-tab-Author']" class="impression-author">
                            <span class="author-prefix">-</span>
                            <span class="" v-html="data['gdl-tab-Author']"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Second Slider -->
    <div v-if="secondSlider" :style="{'background-color':bgColor}" class="splide impression-slider-container global-border-radius secondSlider newFeatureSlider" :class="{'shadow-s': addBorder == 'enable'}">
        <div class="sands-article-vueslidercontainer splide__track">
            <div class="splide__list">
                <div v-for="(data, i) in secondSlider" :key="'second_' + i" class="splide__slide px-4 py-4">
                    <div class="impression-sub-title">
                        <p class="" v-html="data['gdl-tab-Subtitle']"></p>
                        <p v-if="data['gdl-tab-Author']" class="impression-author">
                            <span class="author-prefix">-</span>
                            <span class="" v-html="data['gdl-tab-Author']"></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Splide from '@splidejs/splide';

export default {
    name: "ImpressionSlidingText",

    created() {
        this.firstSlider = JSON.parse(this.settingsPerm.impressionTextSectionRepeater);
        this.secondSlider = JSON.parse(this.settingsPerm.impressionTextSectionRepeater2);
        this.mount_splide();
    },

    mounted() {
        this.setEqualHeight();
        window.addEventListener("resize", this.setEqualHeight);
    },

    data() {
        return {
            firstSlider: [],
            secondSlider: [],
            splide: null,
            bgColor: this.settingsPerm.boxBgColor,
            addBorder: this.settingsPerm.addBorder,
        };
    },

    props: {
        settingsPerm: Object
    },

    methods: {
        mount_splide: function () {
            let thiz = this;
            setTimeout(function () {
                if (!thiz.splide) {
                    // first slider
                    thiz.splide = new Splide('.firstSlider', {
                        classes: {
                            prev: 'splide__arrow--prev previmpres',
                            next: 'splide__arrow--next nextimpres',
                            arrow: 'splide__arrow arrowimpres',
                        },
                        perPage: 1,
                        perMove: 1,
                        rewindByDrag: true,
                        gap: '1rem',
                        autoplay: true,
                        loop: true,
                        interval: 8000,
                        rewind: true,
                    });

                    // Second Slider
                    thiz.secondSplide = new Splide('.secondSlider', {
                        classes: {
                            prev: 'splide__arrow--prev previmpres',
                            next: 'splide__arrow--next nextimpres',
                            arrow: 'splide__arrow arrowimpres',
                        },
                        perPage: 1,
                        perMove: 1,
                        rewindByDrag: true,
                        gap: '1rem',
                        autoplay: true,
                        loop: true,
                        interval: 8000,
                        rewind: true,
                    });

                    thiz.splide.mount();
                    thiz.secondSplide.mount();
                }
            }, 100);
        },
        truncateText(text, maxLength = 200) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        setEqualHeight() {
        // Check if the screen width is greater than or equal to 768px
            if (window.innerWidth >= 768) {
                const impressionContainer = document.querySelector(".impression-container");
                const cardContainer = document.querySelector(".card-container");

                if (impressionContainer && cardContainer) {
                const height = impressionContainer.offsetHeight;
                cardContainer.style.height = `${height}px`;
                }
            } else {
                // Reset the height on smaller screens
                const cardContainer = document.querySelector(".card-container");
                if (cardContainer) {
                cardContainer.style.height = "auto";
                }
            }
        },
    },
};
</script>

<style>
.previmpres {
    display: none !important;
}

.nextimpres {
    display: none !important;
}

.arrowimpres {
    display: none !important;
}

.impression-author {
    margin-top: 0.5rem !important;
    margin-bottom: 2rem !important;
    font-size: clamp(14px, 1vw, 18px);
    font-style: italic;
    line-height: 36px;
}

.card-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;
    /* padding: 1rem; */
    box-sizing: border-box; /* Ensures that padding and borders are included in width and height */
}

.impression-slider-container {
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
    overflow: hidden;
    border-radius: 30px;
    flex: 1 1 50%;
}

.firstSlider,
.secondSlider {
    height: 50%;
}

.impression-sub-title {
    overflow-y: auto;
    max-height: 26rem;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding: 20px;
    font-size: clamp(14px, 1vw, 18px);
}

.impression-sub-title::-webkit-scrollbar {
    display: none;
}


@media only screen and (max-width: 767px) {
    .impression-slider-container {
        height: auto;
    }
}
@media only screen and (min-width: 1743px) {
    .impression-sub-title {
       max-height: 50rem !important;
    }
}
@media only screen and (min-width: 1200px) {
    .impression-sub-title {
        padding: 40px;
        max-height: 40rem;
    }
}
</style>
